<style scoped lang="less">
    .asset-print-container{
        position: relative;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        font-size: 12px;
        z-index: 10000;
        overflow-y:scroll;
        color: #000;
        background: white;
    }
    .close-editor-btn{
        position: absolute;
        top: 20px;
        right: 20px;
    }
    @media print {
        .close-editor-btn{
            display: none;
        }
    }
    .print-content{
        /* display: inline-block; */
        width: 182mm;
        /*height: 280mm;*/
        // text-align: center;
        // line-height: 14px;
        padding: 5mm 3mm;
        box-sizing: content-box;
    }
    .table{
        width: 100%;
        .row {
            // padding: auto;
            width: 100%;
            display: flex;
            color: #515a6e;
            border-top: 1px solid #666;
            border-right: 1px solid #666;
            border-left: 1px solid #666;
            & > div {
                height: 38px;
                line-height: 38px;
                 word-wrap: break-word;
                flex: 0.25;
                display: inline-block;
                text-align: center;
            }
            & > :not(:first-child) {
                border-left: 1px solid #666;
            }
            .multiple-inline {
                display: inline-flex;
                line-height: 1;
                flex-flow: column;
                justify-content: center;
            }
        }
    }
    .ivu-table-wrapper{
        border-color: #666;
    }
    .ivu-table:after, .ivu-table:before {
        content: "";
        display: none;
    }
    .ivu-table div{
        height: 38px;
        padding: 0 12px;
        text-align: center;
        word-wrap: break-word;
        width: 25%;
        border-color: #666;
    }
    .asset-exdiva{
        display: block;
        white-space: pre-line;
        text-align: left;
        padding-left: 12px;
    }
    .table-s {
        width: 100%;
        border-spacing: 0;
                /*表格设置合并边框模型*/
        border-collapse: collapse;
        text-align: center;
        color: #515a6e;
        border:1px solid #666;
        td {
          width: 25%;
          min-height: 38px;
          line-height: 38px;
        }
        .remark {
          padding: 10px;
          font-size: 0.25rem;
          li {
            list-style: none;
            line-height: 18px;
          }
        }
    }
</style>
<template>
  <div
    v-show="is_show"
    v-dom-portal
    class="asset-print-container"
  >
    <div class="close-editor-btn">
      <Button
        type="primary"
        icon="md-print"
        @click="rePrint"
      >
        打印
      </Button>
      <Button
        type="warning"
        icon="md-close"
        @click="close"
      >
        关闭
      </Button>
    </div>
    <div     
      v-if="assets.length"
      class="print-content"
    >
      <table
        class="table-s"
        border="1"
      >
        <tr>
          <td colspan="4">
            <h2>固定资产领用单</h2>
          </td>
        </tr>
        <tr>
          <td>
            姓名
          </td>
          <td>
            {{ customer_account }}
          </td>
          <td>
            团队
          </td>
          <td>
            {{ customer_team }}
          </td>
        </tr>
        <tr>
          <td>
            岗位
          </td>
          <td colspan="3">
            {{ customer_job }}
          </td>
        </tr>
        <tr>
          <td colspan="4">
            领取&挂靠设备清单
          </td>
        </tr>
        <tr>
          <td>
            序号
          </td>
          <td>
            资产编号
          </td>
          <td>
            资产名称
          </td>
          <td>
            资产序号
          </td>
        </tr>
        <tr
          v-for="(asset, index) in assets"
          :key="index"
        >
          <td>
            {{ index+1 }}
          </td>
          <td>
            {{ asset.sn || '-' }}
          </td>
          <td>
            {{ asset.asset_name.name }}
          </td>
          <td>
            {{ asset.uid }}
          </td>
        </tr>
        <tr>
          <td colspan="4">
            <ul class="remark">
              <li>1、本人确认已领取以上固定资产及相关配件，在使用期间将妥善保管、使用及维护。</li>
              <li>2、若使用/挂靠期间，因人为或使用不当造成设备损坏，将按照公司固定资产赔偿制度进行相应赔偿。</li>
              <li>3、若资产的使用人发生变化，则及时提交资产转移/归还申请，离职前及时完成资产的转移和交接手续。</li>
              <li>4、以上固定资产仅供工作使用。</li>
            </ul>
          </td>
        </tr>
        <tr>
          <td>
            签名
          </td>
          <td />
          <td>
            日期
          </td>
          <td />
        </tr>
      </table>
    </div>
    <!-- <div
      v-if="assets.length"
      class="print-content"
    >
      <div class="table">
        <div class="row">
          <div style="flex:1">
            <h1>固定资产领用单</h1>
          </div>
        </div>
        <div class="row">
          <div>姓名</div>
          <div>{{ customer_account }}</div>
          <div>工号</div>
          <div>{{ customer_uid }}</div>
        </div>
        <div class="row">
          <div>团队</div>
          <div>{{ customer_team }}</div>
          <div>岗位</div>
          <div>{{ customer_job }}</div>
        </div>
        <div class="row">
          <div style="flex:1">
            固定资产清单
          </div>
        </div>
        <div class="row">
          <div>资产名称(型号)</div>
          <div>固定资产编号</div>
          <div>资产序列号</div>
          <div>资产附件</div>
        </div>
        <template v-for="(asset, index) in assets">
          <div
            :key="asset.id"
            class="row"
          >
            <div class="multiple-inline">
              <span>{{ asset.asset_name.name }}</span>
              <div
                v-if="asset.asset_model"
                style="line-height: 14px"
              >
                ({{ asset.asset_model }})
              </div>
            </div>
            <div>{{ asset.uid }}</div>
            <div>{{ asset.sn || '-' }}</div>
            <div>
              <span class="asset-exdiva">{{ asset.exdiva || '-' }}</span>
            </div>
          </div>
          <div
            v-if="(index > 0 && index % 15 === 0) || index === assets.length - 1"
            :key="asset.id"
            class="row"
          >
            <div style="flex:1;height:auto">
              <p style="line-height: 20px; padding:10px 20px">
                本人确认已领取以上固定资产及其配件，在使用期间将妥善保管、使用及维护。若因人为或使用不当造成损坏，按合理价格赔偿。
              </p>
            </div>
          </div>
          <div
            v-if="(index > 0 && index % 15 === 0) || index === assets.length - 1"
            :key="asset.id"
            class="row"
            style="border-bottom: 1px solid #666; margin-bottom: 10px;s"
            :style="{
              pageBreakAfter: index === assets.length - 1? 'auto':'always'
            }"
          >
            <div>签名</div>
            <div />
            <div>日期</div>
            <div />
          </div>
        </template>
        <div style="text-align:center;color:rgb(81, 90, 110);">
          固定资产仅供工作使用，离职前应完成归还。
        </div>
      </div>
    </div> -->
  </div>
  <!--<div class="line text-right">
                <qrcode :value="asset.uid" :size="80"></qrcode>
            </div>-->
</template>
<script>
  import Util from '../../../libs/util';
  export default {
    data() {
      return {
        is_show: false,
        assets: []
      }
    },
    computed: {
      cur_customer() {
        return this.$store.state.cur_customer;
      },
      asset() {
        return this.assets[0];
      },
      customer_account() {
        if (this.asset.customer) {
          return this.asset.customer.account;
        } else {
          return '';
        }
      },
      customer_uid() {
        if (this.asset.customer && this.asset.customer) {
          return this.asset.customer.uid || '';
        } else {
          return '';
        }
      },
      customer_team() {
        if (this.asset.customer && this.asset.customer.team_id) {
          return this.asset.customer.team;
        } else {
          return '';
        }
      },
      customer_job() {
        if (this.asset.customer && this.asset.customer.job_id) {
          return this.asset.customer.job;
        } else {
          return '';
        }
      }
    },
    created() {
      //
    },
    mounted() {
      //
    },
    methods: {
      print(assets, doPrint = true) {
        window.eventHub.$emit('hideApp')
        this.assets = [];
        assets.forEach((asset) => {
          this.assets.push(asset);
        });
        this.is_show = true;
        //Object.assign(this.asset, asset);
        if (doPrint) {
          setTimeout(() => {
            window.print();
          }, 800);
        }
      },
      rePrint() {
        window.print();
      },
      close() {
        window.eventHub.$emit('showApp')
        this.is_show = false;
      }
    }
  }
</script>
